module.exports = __webpack_public_path__ + "static/media/voxaNote.56153cab.png";